import React from 'react';
import classNames from 'classnames';
import {Text, Title} from '@priority-software/priority-style-react';
import styles from './RouteTile.module.scss';
import {ColumnsNamesForRoutes} from '../../constants';
import {Form, Record, Field} from '../../../../stores/Form';

const StatusCircle = ({routesForm, field}: {routesForm: Form; field: Field}) => {
    return (
        <div
            className={styles.statusCircle}
            style={{
                backgroundColor: routesForm.statuses.find(x => x.Statdes === field?.currentValue)
                    .Color,
                marginRight: 4
            }}
        ></div>
    );
};

type RouteTitleTextProps = {
    routeData: Record;
    routesForm: Form;
    colNames: ColumnsNamesForRoutes[];
};

export const RouteTitleSection = ({routeData, routesForm, colNames}: RouteTitleTextProps) => {
    return (
        <>
            {colNames.map((colName, idx) => {
                const isLastChild = idx === colNames.length - 1;
                const field: Field = routeData.getField(
                    routesForm.getColumnByName(colName)?.ID as number
                );
                const isStatusField: boolean = colName === ColumnsNamesForRoutes.STATDES;
                if (idx <= 1) {
                    return (
                        <div
                            key={colName}
                            className={classNames({[styles.statusField]: isStatusField})}
                        >
                            {isStatusField && (
                                <StatusCircle routesForm={routesForm} field={field} />
                            )}
                            <Title
                                skin={'h6'}
                                textColor={'primary-700'}
                                componentClasses={classNames(
                                    styles.infoLabelPadding,
                                    styles.selectableText,
                                    styles.nowrap
                                )}
                            >
                                {field?.currentValue}
                            </Title>
                        </div>
                    );
                } else {
                    return (
                        <div
                            key={colName}
                            className={classNames({[styles.statusField]: isStatusField})}
                        >
                            {isStatusField && (
                                <StatusCircle routesForm={routesForm} field={field} />
                            )}
                            <Text
                                skin={'paragraph-1'}
                                textColor={'secondary-500'}
                                componentClasses={classNames(
                                    styles.infoLabelSmallPadding,
                                    styles.selectableText,
                                    {
                                        [styles.titleFinalCol]: isLastChild
                                    }
                                )}
                                style={{flexShrink: 0}}
                            >
                                {field?.currentValue}
                            </Text>
                        </div>
                    );
                }
            })}
        </>
    );
};
